import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"

import { SearchRecipeContext } from "../contexts/SearchRecipeContext"
import { ShowSearchContext } from "../contexts/ShowSearchContext"
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition"
import { useGuide } from "../contexts/GuideContext"

function VoiceRecognition({ setVoiceMessage }) {
    const history = useHistory()
    const guide = useGuide()
    const { setNotSupport } = guide
    const { allRecipes } = React.useContext(SearchRecipeContext)
    const { setShowPage } = React.useContext(ShowSearchContext)
    const [message, setMessage] = useState("")

    const commands = [
        {
            command: "find (ingredients) * (please)",
            callback: ingredients => findRecipe(ingredients)
        },
        {
            command: "search (for) * (please)",
            callback: ingredients => findRecipe(ingredients)
        },
        {
            command: "go home",
            callback: () => handleGoHome()
        },
        {
            command: "go back",
            callback: () => handleGoBack()
        },
        {
            command: "check (recipe) (number) * (please)",
            callback: position => handleCheckRecipe(position)
        },
        {
            command: "reset (voice)",
            callback: ({ resetTranscript }) => resetTranscript(), matchInterim: true
        }
    ]
    const { transcript } = useSpeechRecognition({ commands })
    const msg = new SpeechSynthesisUtterance()
    msg.volume = 5
    const voices = window.speechSynthesis.getVoices()

    useEffect(() => {
        history.replace(`/search/${message.toLowerCase()}`)
        setVoiceMessage(message)
    }, [message, history, setVoiceMessage])

    useEffect(() => {
        if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
            setNotSupport( true )
            return null
        }
    }, [setNotSupport])

    if (SpeechRecognition.browserSupportsContinuousListening) {
        SpeechRecognition.startListening({ continuous: true })
        SpeechRecognition.browserSupportsSpeechRecognition() && console.log("start listening")
    }

    const getFeedback = text => {
        msg.text = text
        msg.voice = voices[1]
        speechSynthesis.speak(msg)
    }

    const findRecipe = ingredients => {
        console.log(transcript)
        getFeedback(`Here's the result for ${ingredients}!`)
        setMessage(ingredients.toLowerCase())
    }

    const handleCheckRecipe = position => {
        // console.log(transcript)
        const index = findRecipeIndex(position)
        if (index === undefined || index === null) {
            getFeedback("Please indicate recipe number")
            return
        }
        const recipe = [...allRecipes].splice(index, 1)[0]
        // console.log(recipeId)
        if (recipe === undefined) {
            getFeedback("Recipe doesn't exist in the gallery")
        } else {
            history.push(`/searchRecipe/${recipe.id}`)
            setShowPage(true)
        }
    }

    const findRecipeIndex = position => {
        const numbers = [2, 3, 7, 8, 9, 10]

        let index
        numbers.forEach(item => {
            if (String(item) === String(position.toLowerCase())) {
                index = parseInt(item - 1)
            } else {
                switch (position) {
                case "one":
                    index = 0
                    break
                case "two":
                case "to":
                    index = 1
                    break
                case "free":
                    index = 2
                    break
                case "for":
                    index = 3
                    break
                case "V":
                case "v":
                    index = 4
                    break
                case "six":
                    index = 5
                    break
                default:
                    index = 11
                    break
                }
            }

        })

        index === undefined ? msg.text = "Can't find recipe" : msg.text = `Check recipe ${index + 1}!`
        msg.voice = voices[1]
        speechSynthesis.speak(msg)

        return index
    }

    const handleGoHome = () => {
        getFeedback("You're now at home!")
        history.push("/")
    }

    const handleGoBack = () => {
        getFeedback("You're at the previous page")
        history.goBack()
        setShowPage(false)
    }

    return (
        <>
            {/* <p>{transcript}</p> */}
            {/* <p>{message}</p> */}
        </>
    )
}

export default VoiceRecognition
